export default __webpack_public_path__ + "static/hero_left-f3677a37fe379271c6c4b0b0f6ae3639.png";